// Libs
import axios from 'axios';
import { reset } from 'redux-form'

// Axios
import { serverAPI } from '../../index'

// Actions
import { changeAuth, changeFirstTime } from '../Auth/actions'
import { resetDashboardData, changeDashboardData } from '../Dashboard/actions'
import { resetFilterPanelParams } from '../FilterPanel/actions'
import { changeHeaderVisible } from '../Header/actions'
import { changeSpCases } from '../MyCasesPage/actions'

// Action types
export const SIGN_OUT = 'change_auth'


export function signOut() {
  const token = localStorage.getItem('token')

  return async function (dispatch) {
    if (typeof window._axisWidgetLogout === 'function') {
      try {
        await window._axisWidgetLogout()
      } catch (error) {
        console.error('❌ [COMACORDO] Erro no logout do Axis:', error)
      }
    } else {
      console.warn('⚠️ [COMACORDO] Widget do Axis não está disponível')
    }
    
    await new Promise(resolve => setTimeout(resolve, 500))
    
    await serverAPI.post('/user/sign-out', { token })
    
    // Remove user data in local storage
    let oldWidget = localStorage.getItem('user-widget')
    localStorage.clear()
    localStorage.setItem('user-widget', oldWidget)

    // Reset redux data
    dispatch(changeAuth(false))
    dispatch(changeFirstTime(false))
    dispatch(changeHeaderVisible(''))
    dispatch(resetDashboardData())
    dispatch(resetFilterPanelParams())
    dispatch(reset('filter'))

    // Redirect to '/login'
    document.location.href = '/login'
  }
}
